var map = {
	"./facebook.png": "d7b6",
	"./instagram.png": "9e37",
	"./line.png": "a390",
	"./phone.png": "3ed0",
	"./skype.png": "0c94",
	"./telegram.png": "cddb",
	"./twitter.png": "226e",
	"./wechat.png": "7696",
	"./whatsapp.png": "b1b1",
	"./zalo.png": "49ea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4e6e";